export default __webpack_public_path__ + "static/media/icon-media-link.894be600c81da81ffb967138239c0246.svg";